<template>
  <Transition :mode="mode" :name="name">
    <slot/>
  </Transition>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const { mode = "out-in", isBack = false } = defineProps<{
  readonly mode?: "out-in" | "in-out";
  readonly isBack?: boolean;
}>();

const name = computed(() => isBack ? "window-back" : "window-next");
</script>